import { Button } from "@mui/material";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { notFoundPageStyles } from "./styles";
import { enterpriseName, isEnterprise } from "../theme";

const NotFound: React.FC = () => {
  useEffect(() => {
    document.title = `Page Not Found - ${
      isEnterprise ? enterpriseName : "OmMuse"
    }`;
  }, []);
  return (
    <div style={notFoundPageStyles.notFoundPageContainer}>
      <h1>{"The page you're looking for can't be found."}</h1>
      <Link to="/my-tracks" style={notFoundPageStyles.goToMainPageButtonLink}>
        <Button variant="contained" sx={notFoundPageStyles.goToMainPageButton}>
          Go to Main Page
        </Button>
      </Link>
    </div>
  );
};

export default NotFound;
